import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Link,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

/**
 * 店舗用配送状況確認モーダル
 * @param root0 コンポーネントのプロップス
 */
export default function DeliveryDialog({ open, setOpen }: Props) {
  const sites: { name: string; url: string }[] = [
    { name: "西濃運輸", url: "https://track.seino.co.jp/cgi-bin/gnpquery.pgm" },
    { name: "近物レックス", url: "https://www8.kinbutsurex.co.jp/GenpyoShokai/WGNSY010.aspx" },
    { name: "福山通運", url: "https://corp.fukutsu.co.jp/situation/tracking_no" },
    { name: "N-LOGI", url: "https://www.nikkon-nlogi.com/tms/tms/screen/TMSS0070" },
    { name: "飛騨運輸", url: "http://www.hida-unyu.co.jp/WP_HIDAUNYU_WKSHO_GUEST/KW_MENU01.do" },
    { name: "札樽自動車運輸", url: "http://trace.sasson.co.jp/traceweb/" },
    { name: "JPロジ", url: "https://www.jp-logistics.jp/fwexphp/inquiry/chase/init" },
    {
      name: "名鉄運輸",
      url: "https://ap.meitetsuunyu.co.jp/webtrace/webtsuiseki/webtsuiseki.aspx",
    },
    { name: "新潟運輸", url: "https://www.niigataunyu.co.jp/tracking/" },
    { name: "佐川急便", url: "https://k2k.sagawa-exp.co.jp/p/sagawa/web/okurijoinput.jsp" },
    { name: "久留米運送", url: "https://www4.kurumeunsou.co.jp/kurume-trans/toi_frm.asp" },
  ];
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Box p={2}>
        <DialogTitle>配送状況確認</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} px={5} mt={1}>
            {sites.map((s) => (
              <Grid item xs={6} key={s.name}>
                <Link
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="always"
                  sx={{
                    color: "#0000EE",
                    textDecorationColor: "#0000EE",
                    "&:visited": {
                      color: "#551A88",
                      textDecorationColor: "#551A88",
                    },
                    "&:hover": {
                      color: "#551A88",
                      textDecorationColor: "#551A88",
                    },
                  }}
                  variant="body1"
                >
                  {s.name}
                </Link>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="custom-outlined" onClick={() => setOpen(false)}>
            閉じる
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
